import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const BiltyDetailPage = lazy(() => import("@/pages/bilty.$id.page"));

export const Route = createFileRoute("/bilty/$id")({
  component: BiltyDetailPage,
});
